import { Flex, Stack } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import Body2 from '@components/typography/Body2';
import { antlerStyle } from '@constants/styles';
import { useMemo } from 'react';

const PlanTypeCard = ({ planType, plans, bullets, onSelect }) => {
  const subtitle = useMemo(() => {
    if (!plans) return '';

    if (!plans.length) return 'No plans';

    const min = Math.floor(plans[0].annualPremium / 12).toFixed(0);
    const max = (plans[plans.length - 1].annualPremium / 12).toFixed(0);
    return `$${min} - $${max} / month`;
  }, [plans]);

  return (
    <Flex maxW="100%" flexDir="column" flex={1} p={8} boxShadow={antlerStyle.boxShadow} borderRadius={12} gap={4}>
      <Flex justifyContent="space-between" alignItems="center">
        <Body1 bold>Plan {planType}</Body1>
        <Body2>{subtitle}</Body2>
      </Flex>
      <Stack py={4} spacing={3}>
        {bullets.map((bullet) => (
          <Flex key={bullet} gap={2}>
            <Body1 sx={{ listStyleType: 'circle' }}>&#x2022;</Body1>
            <Body1>{bullet}</Body1>
          </Flex>
        ))}
      </Stack>
      <Button mt="auto" onClick={() => onSelect(planType)}>
        Select
      </Button>
    </Flex>
  );
};

export default PlanTypeCard;
